import React from 'react'
import styled from '@emotion/styled'
import {InputSelect} from '@vio/atlas/InputSelect'
import {cssTheme} from '@vio/atlas/themes'

interface SemanticPaletteSelectorProps {
  selectedPalette: string
  availablePalettes: string[]
  onChange: (palette: string) => void
}

const SelectorWrapper = styled.div`
  width: 100%;
  margin-top: ${cssTheme.layout.spacing.s100};
`

export const SemanticPaletteSelector = ({
  selectedPalette,
  availablePalettes,
  onChange
}: SemanticPaletteSelectorProps) => {
  const handleChange = (value: string) => {
    onChange(value)
  }

  return (
    <SelectorWrapper>
      <InputSelect
        id="semantic-palette-selector"
        name="semantic-palette-selector"
        value={selectedPalette}
        onChange={handleChange}
        label="Select palette"
        size="sm"
      >
        {availablePalettes.map(palette => (
          <option key={palette} value={palette}>
            {palette}
          </option>
        ))}
      </InputSelect>
    </SelectorWrapper>
  )
}
